import React, { useEffect, useState } from 'react'
import "./Quote.css"

import { db } from "./Firebase"
import { addDoc, collection, serverTimestamp } from "firebase/firestore";

function Quote() {

  const [quoteData, setQuoteData] = useState({
    name: "",
    email: "",
    number: "",
    service: '',
    message: '',
    read: false
  })

  const [submit, setSubmit] = useState(false)
  const clientCollectionRef = collection(db, "quotes")

  const handleChange = (event) => {
    const { name, value } = event.target
    setQuoteData(prevData => ({
      ...prevData,
      [name]: value
    }))
  }

  const handleSubmit = async (event) => {
    try {
      event.preventDefault()
      await addDoc(clientCollectionRef, {
        fullname: quoteData.name,
        email: quoteData.email,
        number: quoteData.number,
        service: quoteData.service,
        details: quoteData.message,
        read: quoteData.read,
        createdAt: serverTimestamp()
      })

      setSubmit(true)
      setQuoteData({
        name: "",
        email: "",
        number: "",
        service: '',
        message: ''
      })

    } catch (error) {
      alert(error.code)
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setSubmit(false)
    }, 5000)

    return () => { clearInterval(interval) }
  }, [])

  return (
    <div className='body' id="body">
      <div className="quote-container">
        <div id="toast" className={submit ? "show" : ""}>
          <i className="fa-solid fa-check"></i> Request Sent Successfully!
        </div>

        <h1>Book Furnitures</h1>
<p className="form-intro">
  Fill out this form to request custom furniture, interior styling, or collaborations with Morara Homes.
</p>

        <form id="quote-form">
          <label htmlFor="name">Full Name</label>
          <input
            type="text"
            id="name"
            name="name"
            required
            onChange={handleChange}
            value={quoteData.name}
            placeholder='Eg: Ian Nyachiro'
          />

          <label htmlFor="email">E mail</label>
          <input
            type="email"
            id="email"
            name="email"
            required
            onChange={handleChange}
            value={quoteData.email}
            placeholder='Eg: iannyachiro@gmail.com'
          />

          <label htmlFor="number">Phone Number</label>
          <input
            type="tel"
            id="phone_number"
            name="number"
            required
            onChange={handleChange}
            value={quoteData.number}
            placeholder='Eg: 0799589076'
          />

          <label htmlFor="service">Service</label>
          <input
            type="text"
            id="service"
            name="service"
            required
            onChange={handleChange}
            value={quoteData.service}
            placeholder='Eg: Living Room Set, Office Desk, Dining Table, Bedroom Wardrobe'

          />

          <label htmlFor="message">Additional Details</label>
          <textarea
            id="message"
            name="message"
            rows="4"
            required
            onChange={handleChange}
            value={quoteData.message}
            placeholder='Eg: We need a custom sofa set for our living room with a modern design.'

          ></textarea>

          <button type="submit" id="submitBtn" onClick={handleSubmit}>Submit Request</button>
        </form>
      </div>
    </div>
  )
}

export default Quote
